import {
	Container,
	ContainerProps,
	DataAttributes,
	Overline as OverlineComponent,
	respondTo,
} from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FunctionComponent } from "react";

const ContainerWithProps: FunctionComponent<ContainerProps> = (props) => (
	<Container {...props} padding="large" />
);

export type RootProps = DataAttributes<{
	"full-width-image": boolean;
}>;

export const ImageContainer = styled.div``;
export const Image = styled.img``;
export const TextContainer = styled(ContainerWithProps)``;
export const Overline = styled(OverlineComponent)``;
export const Heading = styled.h3``;
export const Body = styled.div``;

export const Root = styled.div<RootProps>`
	${({ theme }) => {
		const largeContainer = theme.components.container.sizes.large;

		return css`
			${ImageContainer} {
				padding: ${largeContainer.paddingVertical}
					${largeContainer.paddingHorizontal};
				padding-bottom: 0;
				text-align: center;
			}

			${Image} {
				display: block;
				max-width: 100%;
			}

			${Overline},
			${Heading} {
				text-align: center;
			}

			&[data-full-width-image] {
				${ImageContainer} {
					padding: 0;
				}

				${Image} {
					width: 100%;
				}
			}

			${respondTo(theme, "mobile")} {
				&:not([data-full-width-image]) {
					${ImageContainer} {
						padding: ${largeContainer.mobilePaddingVertical}
							${largeContainer.mobilePaddingHorizontal};
						padding-bottom: 0;
					}
				}
			}
		`;
	}}
`;
